import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertsService } from '../../../alerts.service';
import { AuthService } from '../../../auth.service';
import { TokenStorageService } from '../../../token-storage.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-forgot_password',
  templateUrl: './forgot_password.component.html',
  styleUrls: ['./forgot_password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;

  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(private formBuilder: FormBuilder, private router: Router, private alertService: AlertsService, private modalService: ModalService, private authService: AuthService, private tokenStorage: TokenStorageService) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    })
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      this.router.navigate(['']);
    }
  }

  onEmailInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toLowerCase();
    this.forgotPasswordForm.get('email')?.setValue(input.value, { emitEvent: false });
  }

  onSubmit(): void {
    let email = this.forgotPasswordForm.value.email;
    this.modalService.confirmationDialog('Confirm', 'Please confirm to send an OTP to your email for verification.').subscribe(
      result => {
        if (result === "y") {
          this.authService.resetPassword(email)
            .subscribe({
              next: candidateQualResponse => {
                this.authService.isOTPSent = true;
                this.authService.verificationforgotPasswordEmail = email;
                this.router.navigate(['verify_otp_password']);
              },
              error: err => {
                this.alertService.error('Something went wrong!!!', "Error")
                this.forgotPasswordForm.value.resetForm();
                this.forgotPasswordForm.value.reset({
                  email: ''
                });
              }
            })
        }
      }
    )
  }
}
